var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
export const Root = memo((props) => {
    const { className } = props, rest = __rest(props, ["className"]);
    return (<div className={twMerge('flex flex-initial justify-center hover:bg-light-5 motion-safe:duration-200 items-center bg-light-4 rounded', className)} {...rest}/>);
});
export const Button = memo((props) => {
    const { className } = props, rest = __rest(props, ["className"]);
    return (<button type="button" className={twMerge('m-0.5 motion-safe:duration-200 border-transparent data-[selected=true]:border-dark-2 border-4 px-6 gap-2 py-2 rounded flex flex-col justify-center items-center', className)} {...rest}/>);
});
